import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronUp, ChevronDown, Eye, EyeOff, Download, X, EllipsisVerticalIcon, Info, ChevronsUpDown } from "lucide-react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import TagCostInfoModal from "../components/common/TagCostInfoModal";
import "react-circular-progressbar/dist/styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import CustomSelectInput from "../../Commponent/SelectInput";
import TextInput from "../Commponent/TextInput";
// import { getVehicleClassData } from ".";
// import calendar from "./../../assets/calendar.png";
// import downloadingRed from "./../../assets/downloadingRed.png";
// import { vehicleClasses } from '../../Utils/Constants';
import AddBulkAgents from "../Commponent/AddBulkAgents";
import CustomSelectInput from "./SelectInput";
import { getVehicleClassData } from "../Utils/helper";
import { vehicleClasses } from "../Utils/Constants";
import calendar from "../assets/calendar.png";
import downloadingRed from "../assets/downloadingRed.png";
import CommonTable from "../Common/CommonTable";
import { API } from "../Common/Api";
import { ErrorToast, SuccessToast } from "../Utils/toast";
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS } from "../redux/actions";
import moment from "moment/moment";
import { path } from "../Utils/ScreenPath";
import Loading from "../Common/Loading";



//admin inventory
const AssignedInventory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const GetInventory = useSelector((state) => state.GetInventory.GetInventoryData);
  const GetDistributorNames = useSelector((state) => state.GetDistributorNames.GetDistributorNamesData);
  const GetAgentsNames = useSelector((state) => state.GetAgentsNames.GetAgentsNamesData);
  const GetInventorySummary = useSelector((state) => state.GetInventorySummary.GetInventorySummaryData);
  const [show, setShow] = useState(false);
  const [serialNumber, setSerialNumber] = useState("");
  const [selectedAgent, setSelectedAgent] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: null });
  const [date, setDate] = useState(new Date());
  const [isDateOpen, setIsDateOpen] = useState(false);
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [checkAgentsName, setCheckAgentsName] = useState(false);

  const [file, setFile] = useState("")
  const [activeTab, setActiveTab] = useState('available');
  const [checkGetInventory, setCheckGetInventory] = useState(false);
  const [inventoryData, setInventoryData] = useState([])
  const [inventoryData1, setInventoryData1] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [distributorDataNames, setDistributorDataNames] = useState([]);
  const [agentDataNames, setAgentDataNames] = useState([]);
  const [dealerDataNames, setDealerDataNames] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState("");
  // Agent Inventory cascade: dealers of the selected distributor.
  const [agentTabDealers, setAgentTabDealers] = useState([]);
  const [checKDistributorName, setCheckDistributorName] = useState(false);
  const [agentName, setAgentName] = useState("");
  const [selectedVehicleClass, setSelectedVehicleClass] = useState("");
  const [checkGetInventorySummary, setCheckGetInventorySummary] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [activationFilter, setActivationFilter] = useState("");
  const [dealerActivationFilter, setDealerActivationFilter] = useState(""); // FASTag Activation status (Dealer Inventory tab)
  const [selectedTagRefId, setSelectedTagRefId] = useState(null);
  const [selectedTagActivated, setSelectedTagActivated] = useState(false);
  const [modalInitialTab, setModalInitialTab] = useState('cost');

  // A tag is "activated" once it has been activated for an end user.
  const isRowActivated = (item) => item?.isActivated === true || item?.userActivationStatus === 'Active';

  // Tag Ref ID cell: info icon (pricing) always; a "View Transactions" link that
  // opens the modal straight into the transactions view — only for activated tags.
  const renderTagRefCell = (item) => {
    const tagVal = item.tagRefId || item.serialNumber || '';
    const activated = isRowActivated(item);
    return (
      <div className="flex flex-col gap-0.5">
        <div className="flex items-center gap-2">
          <span>{tagVal}</span>
          {tagVal && (
            <button
              onClick={(e) => { e.stopPropagation(); setSelectedTagRefId(tagVal); setSelectedTagActivated(activated); setModalInitialTab('cost'); }}
              className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-red-500 focus:outline-none"
              title="View pricing details"
            >
              <Info size={14} />
            </button>
          )}
        </div>
        {tagVal && activated && (
          <button
            onClick={(e) => { e.stopPropagation(); setSelectedTagRefId(tagVal); setSelectedTagActivated(true); setModalInitialTab('transactions'); }}
            className="text-xs font-medium text-blue-600 hover:underline text-left w-fit"
          >
            View Transactions
          </button>
        )}
      </div>
    );
  };


  const toggleVisibility = (index, row) => {
    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    // Always open modal for both desktop and mobile
    setModalOpen(!isVisible);

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc") return <ChevronUp className="w-[20px] h-[20px] inline-block ml-1 text-red-500 font-bold" />;
      if (sortConfig.direction === "desc") return <ChevronDown className="w-[20px] h-[20px] inline-block ml-1 text-red-500 font-bold" />;
    }
    return <ChevronsUpDown className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />;
  };


  // ✅ 3. handleSort
  const handleSort = (key) => {
    setCurrentPage(1);
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : prev.direction === "desc" ? null : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };


  // { label: "Assigned To", key: "assignedTo" },


  const columns = [

    {
      label: "Tag Ref ID",
      key: "tagRefId",
      render: (item) => renderTagRefCell(item),
    },
    { label: "Batch Id", key: "batchId" },
    {
      label: "Vehicle Class",
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img src={vehicleClassData.tagimage} alt="Tag" className="w-[34px]" />
            <p>{vehicleClassData.value}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
            </div>
          </div>
        );
      },
    },
    { label: "Assigned To", render: (item) => item.assignedTo?.username },
    { label: "Assigned Date", render: (item) => item.assignedDate ? moment(item.assignedDate).local().format("DD MMMM, YYYY, hh:mm A") : "N/A" },

    // Conditionally add this column only when activeTab is 'agentInventory'
    ...(activeTab === 'agentInventory'
      ? [
        {
          label: "Agent Assigned Date",
          render: (item) =>
            item.agentAssignedDate
              ? moment(item.agentAssignedDate).local().format("DD MMMM, YYYY, hh:mm A")

              : "N/A",
        },
        { label: "Agent Name", render: (item) => item.agentAssignedTo?.username ? item.agentAssignedTo?.username : "N/A" },
        {
          label: "Agent Status",
          key: "status",

          render: (item) => <StatusBadge status={item.agentStatus} />,
        },
      ]
      : []),


    { label: "Supplier", key: "supplier" },
    {
      label: "Created Date", key: "createdAt", render: (item) => moment(item.createdAt).local().format("DD MMMM, YYYY, hh:mm A")
    },
    {
      label: activeTab === 'agentInventory' ? "FASTag Activation Status" : "Distributor Status",
      key: "status",
      render: (item) => activeTab === 'agentInventory' ? <StatusBadge status={item.userActivationStatus || "Inactive"} /> : <StatusBadge status={item.status} />,
    },
    // Distributor Inventory tab: show FASTag Activation status + date.
    ...(activeTab === 'assignWithFile'
      ? [
        {
          label: "FASTag Activation Status",
          render: (item) => item?.isActivated
            ? <span className="inline-block whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-green-100 text-green-900">Activated</span>
            : <span className="inline-block whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-gray-100 text-gray-700">Not Activated</span>,
        },
        {
          label: "FASTag Activation Date",
          render: (item) => <span className="whitespace-nowrap">{item.userActivationDate ? moment(item.userActivationDate).local().format("DD MMMM, YYYY, hh:mm A") : "N/A"}</span>
        }
      ]
      : []),
    ...(activeTab === 'agentInventory'
      ? [
        {
          label: "FASTag Activation Date",
          key: "userActivationDate",
          sortable: true,
          onSort: handleSort,
          sortIcon: getSortIcon,
          render: (item) => item.userActivationDate ? moment(item.userActivationDate).local().format("DD MMMM, YYYY, hh:mm A") : "N/A"
        }
      ]
      : [])
  ];
  const columns1 = [

    {
      label: "Tag Ref ID",
      key: "tagRefId",
      render: (item) => renderTagRefCell(item),
    },
    { label: "Batch Id", key: "batchId" },
    {
      label: "Vehicle Class",
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px] h-auto"
            />
            <p className="text-sm text-gray-700">{vehicleClassData?.value || "N/A"}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? (
                <Eye className="h-5 w-5 text-gray-400" />
              ) : (
                <EyeOff className="h-5 w-5 text-gray-400" />
              )}
            </div>
          </div>

        );
      },
    },
    // { label: "Assigned To", key: "assignedTo" },
    { label: "Supplier", key: "supplier" },
    {
      label: "Uploaded   Date", key: "createdAt", render: (item) => moment(item.createdAt).local().format("DD MMMM, YYYY, hh:mm A")
    },
    {
      label: "Status",
      key: "status",
      render: (item) => <StatusBadge status={item.status} />,
    },
    // ...columns.filter(col => col.key !== 'assignedTo'),
  ];


  // Dealer Inventory columns: the tag is held by a dealer (assignedTo = dealer),
  // and may be further assigned to that dealer's agent (agentAssignedTo).
  const columnsDealer = [
    {
      label: "Tag Ref ID",
      key: "tagRefId",
      render: (item) => renderTagRefCell(item),
    },
    { label: "Batch Id", key: "batchId" },
    {
      label: "Vehicle Class",
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img src={vehicleClassData?.tagimage} alt="Tag" className="w-[34px]" />
            <p>{vehicleClassData?.value}</p>
            <div className="pl-2 flex items-center cursor-pointer" onClick={() => toggleVisibility(idx, item)}>
              {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
            </div>
          </div>
        );
      },
    },
    { label: "Dealer", render: (item) => item.assignedToDealerID?.username || item.assignedTo?.username || "N/A" },
    { label: "Assigned Date", render: (item) => item.assignedDate ? moment(item.assignedDate).local().format("DD MMMM, YYYY, hh:mm A") : "N/A" },
    { label: "Agent Name", render: (item) => item.agentAssignedTo?.username || "N/A" },
    {
      label: "Agent Assigned Date",
      render: (item) => item.agentAssignedDate ? moment(item.agentAssignedDate).local().format("DD MMMM, YYYY, hh:mm A") : "N/A",
    },
    { label: "Agent Status", render: (item) => <StatusBadge status={item.agentStatus} /> },
    { label: "Supplier", key: "supplier" },
    { label: "Created Date", key: "createdAt", render: (item) => moment(item.createdAt).local().format("DD MMMM, YYYY, hh:mm A") },
    {
      label: "FASTag Activation Status",
      render: (item) => item?.isActivated
        ? <span className="inline-block whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-green-100 text-green-900">Activated</span>
        : <span className="inline-block whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-gray-100 text-gray-700">Not Activated</span>,
    },
    {
      label: "FASTag Activation Date",
      render: (item) => <span className="whitespace-nowrap">{item.userActivationDate ? moment(item.userActivationDate).local().format("DD MMMM, YYYY, hh:mm A") : "N/A"}</span>,
    },
  ];

  const currentColumns = activeTab === 'available'
    ? columns1
    : activeTab === 'dealerInventory'
      ? columnsDealer
      : columns;
  const currentColumnsData = activeTab === 'available' ? inventoryData : inventoryData1;



  // Create dynamic summary stats from API data
  const getSummaryStats = () => {
    if (GetInventorySummary?.success && GetInventorySummary?.data) {
      const data = GetInventorySummary.data;
      const total = data.totalFastag?.count || 0;

      const calculatePercentage = (count) => {
        if (!total) return 0;
        const percentage = (count / total) * 100;
        return percentage > 100 ? 100 : percentage;
      };

      return [
        {
          label: "Total FASTag",
          value: total,
          percent: 100,
          color: "#16a34a"
        },
        {
          label: "Distributor Assigned FASTag",
          value: data.distributorAssigned?.count || 0,
          percent: calculatePercentage(data.distributorAssigned?.count || 0),
          color: "#dc2626"
        },
        {
          label: "Dealer Assigned FASTag",
          value: data.dealerAssigned?.count || 0,
          percent: calculatePercentage(data.dealerAssigned?.count || 0),
          color: "#7c3aed"
        },
        {
          label: "Agent Assigned FASTag",
          value: data.agentAssigned?.count || 0,
          percent: calculatePercentage(data.agentAssigned?.count || 0),
          color: "#f59e0b"
        },
        {
          label: "User Assigned FASTag",
          value: data.userAssigned?.count || 0,
          percent: calculatePercentage(data.userAssigned?.count || 0),
          color: "#2563eb"
        },
      ];
    }
    // Fallback to empty stats while loading
    return [
      { label: "Total FASTag", value: 0, percent: 0, color: "#16a34a" },
      { label: "Distributor Assigned FASTag", value: 0, percent: 0, color: "#dc2626" },
      { label: "Dealer Assigned FASTag", value: 0, percent: 0, color: "#7c3aed" },
      { label: "Agent Assigned FASTag", value: 0, percent: 0, color: "#f59e0b" },
      { label: "User Assigned FASTag", value: 0, percent: 0, color: "#2563eb" },
    ];
  };

  const summaryStats = getSummaryStats();


  const getData = () => {
    let params = {
      page: currentPage,
      limit: itemsPerPage,
      status: activeTab == 'available' ? "Unassigned" : 'Assigned',
      search: serialNumber,
      distributor: selectedAgent,
      agent: agentName,
      VC: selectedVehicleClass,
      // Distributor Inventory tab intentionally sends no isAgent filter: it lists the
      // distributor's whole tree, which includes tags already passed on to an agent.
      isAgent: activeTab === 'agentInventory' ? true : undefined,
      userActivationStatus: activationFilter,
      // FASTag Activation status filter — Distributor & Dealer Inventory tabs.
      isActivated: (activeTab === 'dealerInventory' || activeTab === 'assignWithFile') ? dealerActivationFilter : '',
      sortBy: sortConfig.key || undefined,
      sortOrder: sortConfig.direction || undefined,
      // Dealer Inventory tab: scope to dealer-held FASTags server-side.
      // Distributor Inventory tab: scope to the distributor's tree (itself + its
      // dealers), so choosing a distributor keeps the tags it handed to a dealer.
      holder: activeTab === 'dealerInventory'
        ? 'dealer'
        : activeTab === 'assignWithFile'
          ? 'distributorTree'
          : undefined,
      // Narrow to a specific dealer — on the Dealer tab, or via the Agent tab's
      // cascade (Distributor -> Dealer -> Agent).
      dealer: (activeTab === 'dealerInventory' || activeTab === 'agentInventory') ? selectedDealer : ''
    }
    setCheckGetInventory(true)
    dispatch(ACTIONS.GetInventoryAction(params))
  }

  useEffect(() => {
    getData()
  }, [activeTab, serialNumber, currentPage, itemsPerPage, selectedAgent, agentName, selectedDealer, selectedVehicleClass, activationFilter, dealerActivationFilter, sortConfig.key, sortConfig.direction])

  useEffect(() => {
    setCheckDistributorName(true)
    dispatch(ACTIONS.GetDistributorNamesAction());
    setCheckAgentsName(true)
    dispatch(ACTIONS.GetAgentsNamesAction());
    // Dispatch inventory summary API call
    setCheckGetInventorySummary(true)
    dispatch(ACTIONS.GetInventorySummaryAction());
    // All dealer names for the Dealer Inventory "All Dealers" filter.
    API.GetAllDealersNames()
      .then((res) => setDealerDataNames(Array.isArray(res?.data) ? res.data : []))
      .catch(() => setDealerDataNames([]));

  }, [])

  useEffect(() => {
    if (checkAgentsName) {
      if (GetAgentsNames?.status == 200 && GetAgentsNames?.success) {
        const uniqueAgents = Array.from(
          new Map(
            GetAgentsNames?.data?.map((agent) => [agent._id, agent])
          ).values()
        );

        setAgentDataNames(uniqueAgents);
      } else {
        ErrorToast(GetAgentsNames?.message);
      }
      setCheckAgentsName(false)
      // setLoading(false);
    }
  }, [GetAgentsNames])

  useEffect(() => {
    if (checkGetInventory && GetInventory) {
      if (GetInventory.status == 200 && GetInventory.success) {
        if (activeTab === 'available') {
          setInventoryData(GetInventory.data);
        }
        else {
          setInventoryData1(GetInventory.data);
        }
        setCheckGetInventory(false);
      } else {
        ErrorToast(GetInventory.message || "Failed to fetch inventory");
        setCheckGetInventory(false);
      }
    }
  }, [GetInventory])

  useEffect(() => {
    if (checKDistributorName) {
      if (GetDistributorNames?.status == 200 && GetDistributorNames?.success) {
        const uniqueAgents = Array.from(
          new Map(
            GetDistributorNames?.data?.map((agent) => [agent._id, agent])
          ).values()
        );

        setDistributorDataNames(uniqueAgents);
      } else {
        ErrorToast(GetDistributorNames?.message);
      }
      setCheckDistributorName(false)
      // setLoading(false);
    }
  }, [GetDistributorNames])

  // Handle inventory summary API response
  useEffect(() => {
    if (checkGetInventorySummary) {
      setCheckGetInventorySummary(false);
    }
  }, [GetInventorySummary])

  const StatusBadge = ({ status }) => {
    const base = "inline-flex items-center gap-1 whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium align-middle";
    if (status === "Assigned")
      return <span className={`${base} bg-green-100 text-green-900`}><span className="h-2 w-2 bg-green-500 rounded-full" />Assigned</span>;
    if (status === "Unassigned")
      return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Unassigned</span>;
    if (status === "Active")
      return <span className={`${base} bg-green-100 text-green-900`}><span className="h-2 w-2 bg-green-500 rounded-full" />Active</span>;
    if (status === "Inactive")
      return <span className={`${base} bg-red-100 text-red-900`}><span className="h-2 w-2 bg-red-500 rounded-full" />Inactive</span>;
    return null;
  };

  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);

  // Dedicated to the download button: the screen's other loading flags drive
  // the table overlay and a refetch, which a download must not trigger.
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      setCheckGetInventory(true);

      const tabName = activeTab === 'available'
        ? 'available'
        : activeTab === 'assignWithFile'
          ? 'distributor'
          : activeTab === 'dealerInventory'
            ? 'dealer'
            : 'agent';

      const params = {
        tab: tabName,
        status: activeTab === 'available' ? 'Unassigned' : 'Assigned',
        search: serialNumber,
        distributor: selectedAgent,
        agent: agentName,
        dealer: (activeTab === 'dealerInventory' || activeTab === 'agentInventory') ? selectedDealer : '',
        VC: selectedVehicleClass,
        userActivationStatus: activationFilter,
        // Same guard as getData — without this the FASTag Activation filter on the
        // Distributor/Dealer Inventory tabs was applied on screen but dropped from
        // the download, so the file came back unfiltered.
        isActivated: (activeTab === 'dealerInventory' || activeTab === 'assignWithFile') ? dealerActivationFilter : ''
      };

      const blob = await API.DownloadTabWiseExcel(params);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Inventory_${tabName}_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      SuccessToast("Excel file downloaded successfully");
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Excel file");
    } finally {
      setCheckGetInventory(false);
      setIsDownloading(false);
    }
  };
  // const filteredInventory1 = []; // your filtered data logic here

  const handleSubmit = async () => {
    // Submit logic here
    setIsUploading(true);
    let formData = new FormData();
    formData.append('file', file);

    const response = await API.CreateInventory(formData);

    if (response.status === 201) {
      // Handle success
      SuccessToast(response.message);
      getData();
    } else {
      // Handle error
      ErrorToast(response.message);
    }
    setIsUploading(false);
    setShow(false);
  }



  const SubmitButton = () => {
    return (
      <button
        onClick={handleSubmit}
        className="mt-2 bg-[#EE3B31] text-white rounded-full py-2"
      >
        Submit
      </button>
    )
  }


  const handleUpload = (fileRaw) => {
    setFile(fileRaw);
  }

  // The Dealer and Agent tabs are two views of the same Distributor -> Dealer ->
  // Agent cascade, so a dealer picked on one stays picked on the other. Every
  // other tab has no dealer scope and starts clean.
  const isDealerScopedTab = (tab) => tab === 'dealerInventory' || tab === 'agentInventory';

  const handleTab = (tab) => {
    setCurrentPage(1);
    setActiveTab(tab);
    // Reset vehicle class filter when switching away from available tab
    if (tab !== 'available') {
      setSelectedVehicleClass("");
    }
    if (tab !== 'agentInventory') {
      setActivationFilter("");
    }
    // Keep the dealer selection when hopping between the Dealer and Agent tabs;
    // drop it whenever we leave that pair.
    const keepDealer = isDealerScopedTab(tab) && isDealerScopedTab(activeTab);
    if (!keepDealer) {
      setSelectedDealer("");
      setAgentTabDealers([]);
    }
    // The agent filter only exists on the Agent tab.
    if (tab !== 'agentInventory') {
      setAgentName("");
    }
    // Carrying a dealer into the Agent tab: scope its agent list to that dealer
    // so the "All Agents" dropdown matches the dealer that is still selected.
    if (keepDealer && tab === 'agentInventory' && selectedDealer) {
      setCheckAgentsName(true);
      dispatch(ACTIONS.GetAgentsNamesAction(selectedDealer));
    }
  }

  const LeftComponent = () => {
    return (
      <div className="!flex justify-align-start items-center gap-2">
        <div className="!flex justify-start items-center gap-2">
          <div className="flex items-center gap-2">
            <button
              onClick={() => handleTab('available')}
              className={`${activeTab === 'available'
                ? 'bg-red-500 text-white'
                : 'bg-[#FEF5F5] text-[#1F1715]'
                } text-[12px] font-medium lg:px-4 px-2 py-1 lg:py-2 rounded-full`}
            >
              Available Inventory
            </button>

            <button
              onClick={() => handleTab('assignWithFile')}
              className={`${activeTab === 'assignWithFile'
                ? 'bg-red-500 text-white'
                : 'bg-[#FEF5F5] text-[#1F1715]'
                } text-[12px] font-medium lg:px-4 px-2 py-1 lg:py-2 rounded-full`}
            >
              Distributor Inventory
            </button>

            <button
              onClick={() => handleTab('dealerInventory')}
              className={`${activeTab === 'dealerInventory'
                ? 'bg-red-500 text-white'
                : 'bg-[#FEF5F5] text-[#1F1715]'
                } text-[12px] font-medium lg:px-4 px-2 py-1 lg:py-2 rounded-full`}
            >
              Dealer Inventory
            </button>

            <button
              onClick={() => handleTab('agentInventory')}
              className={`${activeTab === 'agentInventory'
                ? 'bg-red-500 text-white'
                : 'bg-[#FEF5F5] text-[#1F1715]'
                } text-[12px] font-medium lg:px-4 px-2 py-1 lg:py-2 rounded-full`}
            >
              Agent Inventory
            </button>

          </div>
        </div>

      </div>
    )
  }
  return (
    <>
      <Loading loading={isUploading} />
      <div className="">

        {/* Summary Cards */}
        <div className="bg-[#FFFFFF] my-[30px] shadow-md rounded-xl p-4">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-800 mb-[16px] mt-[27.5px] f">Inventory Summary</h2>
            <EllipsisVerticalIcon className="text-gray-500 hover:text-gray-700 text-2xl" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 mb-[21px]">
            {summaryStats.map((item, idx) => (
              <div key={idx} className="bg-white rounded-xl p-3 xl:p-4 shadow-sm border flex items-center gap-3 xl:gap-4">
                <div className="w-12 h-12 xl:w-14 xl:h-14 shrink-0">
                  <CircularProgressbar
                    value={item.percent}
                    text={`${item.percent % 1 === 0 ? item.percent : item.percent.toFixed(2)}%`}
                    styles={buildStyles({
                      pathColor: item.color,
                      textColor: "#000",
                      trailColor: "#e5e7eb",
                      textSize: "22px",
                    })}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-lg font-bold text-gray-900 truncate">
                    {item.value.toLocaleString()}
                  </div>
                  <div className="text-[13px] text-gray-500 leading-tight">
                    {item.label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Filters and Actions */}
        <div className="mb-6 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-3 flex-1 min-w-0">
            {/* Search Input */}
            <div className="relative w-full sm:w-56 md:w-60 lg:w-48 xl:w-60">
              <TextInput
                name="serialNumber"
                placeholder="TagRefId / Batch ID"
                value={serialNumber}
                onChange={(e) => {
                  setSerialNumber(e.target.value);
                  setCurrentPage(1);
                }}
                inputClass="pl-5 pr-10 h-[44px] text-sm"
              />
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                <Search className="w-4 h-4" />
              </div>
            </div>

            {/* Vehicle Class Filter - Available & Dealer Inventory */}
            {(activeTab === 'available' || activeTab === 'dealerInventory') && (
              <div className="relative w-full sm:w-40 md:w-44 lg:w-40 xl:w-44">
                <CustomSelectInput
                  name="selectedVehicleClass"
                  label="" // No label for inline layout
                  value={selectedVehicleClass}
                  onChange={(e) => {
                    setSelectedVehicleClass(e.target.value);
                    setCurrentPage(1);
                  }}
                  options={[
                    { name: "All Vehicle Classes", value: "" },
                    ...vehicleClasses.map((vehicle) => ({ ...vehicle, name: vehicle.value, value: vehicle.value })),
                  ]}
                  inputClass="text-sm text-gray-500"
                />
              </div>
            )}

            {/* Distributor filter — Distributor, Agent & Dealer Inventory tabs */}
            {(activeTab === 'assignWithFile' || activeTab === 'agentInventory' || activeTab === 'dealerInventory') && (
              <div className="relative w-full sm:w-40 md:w-44 lg:w-40 xl:w-44">
                <CustomSelectInput
                  name="selectedAgent"
                  label="" // No label for inline layout
                  value={selectedAgent}
                  onChange={(e) => {
                    const distId = e.target.value;
                    setSelectedAgent(distId);
                    setCurrentPage(1);
                    // Reset the cascade below the distributor.
                    setSelectedDealer("");
                    setAgentName("");
                    setCheckAgentsName(true);
                    dispatch(ACTIONS.GetAgentsNamesAction(distId));
                    // Populate the dealer dropdown with this distributor's dealers.
                    API.GetAllDealersNames({ distributorId: distId })
                      .then((res) => setAgentTabDealers(Array.isArray(res?.data) ? res.data : []))
                      .catch(() => setAgentTabDealers([]));
                  }}
                  options={[
                    { name: "All Distributors", value: "" },
                    ...distributorDataNames.map((agent) => ({ name: agent.username, value: agent?._id })),
                  ]}
                  showSearch
                  inputClass="text-sm text-gray-500"
                />
              </div>
            )}

            {/* All Dealers filter — Dealer Inventory tab only */}
            {activeTab === 'dealerInventory' && (
              <div className="relative w-full sm:w-40 md:w-44 lg:w-40 xl:w-44">
                <CustomSelectInput
                  name="selectedDealer"
                  label=""
                  value={selectedDealer}
                  onChange={(e) => {
                    setSelectedDealer(e.target.value);
                    setCurrentPage(1);
                  }}
                  options={[
                    { name: "All Dealers", value: "" },
                    ...dealerDataNames.map((dealer) => ({ name: dealer.username, value: dealer?._id })),
                  ]}
                  showSearch
                  inputClass="text-sm text-gray-500"
                />
              </div>
            )}

            {/* FASTag Activation status filter — Distributor & Dealer Inventory tabs */}
            {(activeTab === 'dealerInventory' || activeTab === 'assignWithFile') && (
              <div className="relative w-full sm:w-40 md:w-44 lg:w-40 xl:w-44">
                <CustomSelectInput
                  name="dealerActivationFilter"
                  label=""
                  value={dealerActivationFilter}
                  onChange={(e) => { setDealerActivationFilter(e.target.value); setCurrentPage(1); }}
                  options={[
                    { name: "Select Status", value: "" },
                    { name: "Activated", value: "true" },
                    { name: "Available", value: "false" },
                  ]}
                  inputClass="text-sm text-gray-500"
                />
              </div>
            )}

            {/* Dealer cascade filter — Agent Inventory tab (dealers of selected distributor) */}
            {activeTab === 'agentInventory' && (
              <div className="relative w-full sm:w-40 md:w-44 lg:w-40 xl:w-44">
                <CustomSelectInput
                  name="agentTabDealer"
                  label=""
                  value={selectedDealer}
                  onChange={(e) => {
                    const dealerId = e.target.value;
                    setSelectedDealer(dealerId);
                    setAgentName("");
                    setCurrentPage(1);
                    setCheckAgentsName(true);
                    // Agents of the selected dealer, or fall back to the distributor's agents.
                    dispatch(ACTIONS.GetAgentsNamesAction(dealerId || selectedAgent));
                  }}
                  options={[
                    { name: "All Dealers", value: "" },
                    // Falls back to every dealer when no distributor narrows the
                    // cascade, so a dealer carried over from the Dealer tab still
                    // shows up here instead of rendering as an empty box.
                    ...(agentTabDealers.length ? agentTabDealers : dealerDataNames)
                      .map((dealer) => ({ name: dealer.username, value: dealer?._id })),
                  ]}
                  showSearch
                  inputClass="text-sm text-gray-500"
                />
              </div>
            )}

            {/* Show this only when Agent Inventory tab is active */}
            {activeTab === 'agentInventory' && (
              <>
                <div className="relative w-full sm:w-40 md:w-44 lg:w-40 xl:w-44">
                  <CustomSelectInput
                    name="AllAgent"
                    value={agentName}
                    onChange={(e) => {
                      setAgentName(e.target.value);
                      setCurrentPage(1);
                    }}
                    options={[
                      { name: "All Agents", value: "" },
                      ...agentDataNames.map((agent) => ({ name: agent.username, value: agent?._id })),
                    ]}
                    showSearch
                    inputClass="text-sm !text-gray-400"
                  />
                </div>
                <div className="relative w-full sm:w-28 md:w-32 lg:w-24 xl:w-28">
                  <CustomSelectInput
                    name="ActivationStatus"
                    value={activationFilter}
                    onChange={(e) => {
                      setActivationFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                    options={[
                      { name: "Select Status", value: "" },
                      { name: "Active", value: "Active" },
                      { name: "Inactive", value: "Inactive" },
                    ]}
                    inputClass="text-sm !text-gray-400"
                  />
                </div>
              </>
            )}
          </div>
          <div className="flex flex-row items-center justify-end gap-2 w-full lg:w-auto shrink-0">
            <button
              className="bg-green-500 hover:bg-green-600 text-white h-[44px] rounded-full px-5 font-semibold flex items-center justify-center space-x-2 transition-colors whitespace-nowrap"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // Mark this as a drill-in so the Master FASTag page keeps its back
                // button; the Settings-menu entry (no state) shows none.
                navigate(path.masterFastag, { state: { fromInventory: true } });
              }}
            >
              <span className="text-xs lg:text-[13px]">Master FASTag</span>
            </button>
            <button
              className="bg-green-500 hover:bg-green-600 text-white h-[44px] rounded-full px-5 font-semibold flex items-center justify-center space-x-2 transition-colors whitespace-nowrap"
              onClick={() => setShow(true)}
            >
              <span className="text-xs lg:text-[13px]">Upload Inventory +</span>
            </button>
          </div>
        </div>

        {/* Date Picker & Download */}
        {/* <div className="flex items-center justify-between mt-2 bg-[#FFFFFF] p-3 rounded-t-[16px] relative">
          <div className="!flex justify-align-start items-center gap-2">
            <div className="flex items-center gap-2">
              <button
                onClick={() => setActiveTab('available')}
                className={`${activeTab === 'available'
                  ? 'bg-red-500 text-white'
                  : 'bg-[#FEF5F5] text-[#1F1715]'
                  } text-[12px] font-medium px-4 py-2 rounded-full`}
              >
                Available Inventory
              </button>

              <button
                onClick={() => setActiveTab('assignWithFile')}
                className={`${activeTab === 'assignWithFile'
                  ? 'bg-red-500 text-white'
                  : 'bg-[#FEF5F5] text-[#1F1715]'
                  } text-[12px] font-medium px-4 py-2 rounded-full`}
              >
                Assigned Inventory
              </button>
            </div>


          </div>
          <div className="flex items-center gap-2">

            <button
              className="!p-2 !bg-[#FFFFFF] !rounded-full border border-[#BEBEBE] transition duration-150 ease-in-out flex justify-center"
              onClick={() => setIsDateOpen((prev) => !prev)}
            >
              <img alt="calendar" src={calendar} className="w-[13px] h-[13px]" />
            </button>

            <button
              onClick={() => handleDownload()}
              className="!p-2 bg-[#FFFFFF] border border-[#BEBEBE] !rounded-full transition duration-150 ease-in-out"
            >
              <img alt="download" src={downloadingRed} className="w-[13px] h-[13px] text-gray-700" />
            </button>

            {isDateOpen && (
              <div className="absolute top-12 right-0 z-50">
                <DatePicker
                  selected={date}
                  onChange={(newDate) => {
                    setDate(newDate);
                    setIsDateOpen(false);
                  }}
                  inline
                />
              </div>
            )}
          </div>
        </div> */}

        <CommonTable
          loading={checkGetInventory}
          isPagination
          paginationClass="items-center justify-between"
          leftComponent={<LeftComponent />}
          columns={currentColumns}
          data={currentColumnsData}
          emptyMessage="No Inventory Found"
          total={GetInventory?.pagination?.total}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          totalPages={Math.ceil(GetInventory?.pagination?.total / itemsPerPage)}
          onDownload={handleDownload}
          downloading={isDownloading}
        />


        {/* Modal for Desktop and Mobile */}
        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl mx-4 p-6 max-h-[90vh] overflow-y-auto">
              <div className="absolute top-4 right-4 gap-3 flex-row flex">
                <button
                  onClick={() => {
                    setModalOpen(false);
                    if (selectedIndex !== null) {
                      toggleVisibility(selectedIndex, selectedClass);
                    }
                  }}
                  className="text-gray-600 hover:text-red-500 p-1"
                >
                  <X size={20} />
                </button>
              </div>
              <h2 className="text-xl font-semibold mb-[4px] text-center pr-16">
                {vehicleData?.value}
              </h2>
              <p className="mb-[30px] text-sm text-center text-gray-600">
                {vehicleData?.description}
              </p>
              <div className="relative w-full flex justify-center items-center py-8 px-4">
                <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                  {/* Image container with classic frame */}
                  <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                    <img
                      src={vehicleData?.cardWebp}
                      alt={vehicleData?.name}
                      className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                    />
                  </div>

                  {/* Elegant bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {show && <AddBulkAgents sidebarTitle="Upload Inventory" onClose={() => setShow(false)} onUpload={handleUpload} BottomComponent={SubmitButton} />}
      {selectedTagRefId && (
        <TagCostInfoModal
          tagRefId={selectedTagRefId}
          isActivated={selectedTagActivated}
          initialTab={modalInitialTab}
          onClose={() => setSelectedTagRefId(null)}
        />
      )}
    </>
  );
};

export default AssignedInventory;
